// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__1Hs10","text":"error_text__9-EEA","cross":"error_cross__2ag1I"};